module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#trending",
      toString: function () {
        return this.url;
      }
    }